import Button from '@lyra/core/components/Button'
import ButtonGroup from '@lyra/core/components/ButtonGroup'
import { X } from '@tamagui/lucide-icons'
import { GestureReponderEvent } from '@tamagui/web'
import React from 'react'
import { StackProps } from 'tamagui'

type Props = {
  label: string
  isDisabled?: boolean
  onPress?: (e: GestureReponderEvent) => void
} & StackProps

export default function OptionsColumnDraggableItem({
  label,
  isDisabled,
  onPress,
  ...stackProps
}: Props) {
  return (
    <ButtonGroup {...stackProps}>
      <Button label={label} flexGrow={1} />
      <Button icon={<X />} onPress={onPress} isDisabled={isDisabled} />
    </ButtonGroup>
  )
}
